import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';
import { loadGameCategories } from './categories';

export default defineModule({
    id: 'games',
    contributes: {
        'sidebar.menu': [
            // Expanded at runtime into one item per game category.
            { key: 'gameCategories', order: 10, load: loadGameCategories }
        ],
        'home.sections': [
            { key: 'hotGames', order: 20, component: overridable('HotGames', () => import(/* webpackChunkName: "home" */ './components/HotGames.vue')) },
            { key: 'popularGames', order: 40, component: overridable('PopularGames', () => import(/* webpackChunkName: "home" */ './components/PopularGames.vue')) }
        ]
    }
});

export { loadGameCategories };
